import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { ClassificationModel } from '@/models/taxonomy/classification';
import { SubjectModel } from '@/models/taxonomy/subject';
import { searchAPI } from '@/providers/apis/search/search';
import axios from 'axios';
import { librariesAPI } from '@/providers/apis/libraries/libraries';
import { CATALOG_MENUS, CAP_SUBJECTS, CAP_CATEGORIES } from '@/utils/constants';
import access from '@/permission/permission';
import { sortByProperty } from '@/utils/utils';
import { taxonomySerializer } from '@/providers/serializers/taxonomy/taxonomy';

export default ({
    namespaced: true,
    state: {
        categoryList: [],
        subjectList: [],
        courseList: [],
        summaryResource: {},
        summaryQuestion: {},
        learnerContent: {},
        courseCatalog: {},
        collectionCatalog: {},
        assessmentCatalog: {},
        resourceCatalog: {},
        questionCatalog: {},
        offlineActivityCatalog: {},
        partnerContentCatalog: {},
        crossWalkData: [],
        summarySubjects: [],
        frameworkList: [],
        standardCompetencyList: [],
        domainList: [],
        selectedData: {},
    },
    mutations: {
        fetchCategory(state: any, category: ClassificationModel[]) {
            let categoryList: ClassificationModel[] = category;
            if (access.isCapLibrary) {
                categoryList = categoryList.map((cat) => {
                    cat.isDisabled = true;
                    if (CAP_CATEGORIES.indexOf(cat.id as any) !== -1) {
                        cat.isDisabled = false;
                    }
                    return cat;
                });
            }
            state.categoryList = categoryList;
        },
        fetchSubject(state: any, subject: SubjectModel[]) {
            let subjectsList: SubjectModel[] = subject;
            if (access.isCapLibrary) {
                subjectsList.map((sub) => {
                    sub.isDisabled = true;
                    if (CAP_SUBJECTS.indexOf(sub.id) !== -1) {
                        sub.isDisabled = false;
                    }
                    return sub;
                });
                subjectsList = subjectsList.sort((a: any, b: any) => {
                    return CAP_SUBJECTS.indexOf(a.id) - CAP_SUBJECTS.indexOf(b.id);
                });
                sortByProperty(subjectsList, 'isDisabled', 'ASC');
            }
            state.subjectList = subjectsList;
        },

        fetchFrameWork(state: any, subject: any[]) {
            let subjectsList: any[] = subject;
            if (access.isCapLibrary) {
                subjectsList.map((sub) => {
                    sub.isDisabled = true;
                    if (CAP_SUBJECTS.indexOf(sub.id) !== -1) {
                        sub.isDisabled = false;
                    }
                    return sub;
                });
                subjectsList = subjectsList.sort((a: any, b: any) => {
                    return CAP_SUBJECTS.indexOf(a.id) - CAP_SUBJECTS.indexOf(b.id);
                });
                sortByProperty(subjectsList, 'isDisabled', 'ASC');
            }
            state.frameworkList = subjectsList;
        },

        fetchDomain(state: any, domain: any[]) {
            const domainList: any[] = domain;
            state.domainList = domainList;
        },

        fetchCodes(state: any, codes: any[]) {
            const codesList: any[] = codes;
            state.standardCompetencyList = codesList;
        },

        fetchSummarySubjects(state: any, subject: SubjectModel[]) {
            state.summarySubjects = subject;
        },

        fetchCourse(state: any, course: any) {
            state.courseList = course;
        },
        fetchSummaryCatalog(state: any, catalog: any) {
            state.summaryResource = catalog[0];
            state.summaryQuestion = catalog[1];
        },

        fetachLearnerContent(state: any, content: any) {
            let contentList: any = {};
            Object.keys(content.params).map((param: any, index: number) => {
                contentList[param] = content.response[index];
            });
            contentList = { ...state.learnerContent, ...contentList };
            state.learnerContent = contentList;
        },

        courseCatalogSearch(state: any, course: any) {
            state.courseCatalog = course;
        },

        collectionCatalogSearch(state: any, collection: any) {
            state.collectionCatalog = collection;
        },

        assessmentCatalogSearch(state: any, assessment: any) {
            state.assessmentCatalog = assessment;
        },
        resourceCatalogSearch(state: any, resource: any) {
            state.resourceCatalog = resource;
        },
        questionCatalogSearch(state: any, question: any) {
            state.questionCatalog = question;
        },
        librariesCatalogSearch(state: any, libraries: any) {
            state.partnerContentCatalog = libraries;
        },
        fetchCrossWalk(state: any, crossWalk: any) {
            state.crossWalkData = crossWalk;
        },
        offlineActivityCatalogSearch(state: any, offlineActivity: any) {
            state.offlineActivityCatalog = offlineActivity;
        },
        getSelectedData(state: any, selectedData: any) {
            state.selectedData = selectedData;
        },
    },
    actions: {
        fetchCategory({ commit }: { commit: any }) {
            return taxonomyAPI.fetchTaxonomyClassifications().then((classification) => {
                commit('fetchCategory', classification);
            });
        },

        fetchSubject({ commit }: { commit: any }, categoryId: string) {
            return taxonomyAPI.fetchSubjects(categoryId).then((subjects) => {
                commit('fetchSubject', subjects);
            });
        },

        fetchSummarySubjects({ commit }: { commit: any }, categoryId: string) {
            return taxonomyAPI.fetchSubjects(categoryId).then((subjects) => {
                commit('fetchSummarySubjects', subjects);
            });
        },

        fetchFrameWork({ commit }: { commit: any }, frameWrok: any) {
            commit('fetchFrameWork', frameWrok);
        },

        fetchCourse({ commit }: { commit: any }, subject: any) {
            return taxonomyAPI.fetchTaxonomyCourse(subject).then((courses) => {
                commit('fetchCourse', courses);
            });
        },

        fetchDomain({ commit }: { commit: any }, course: any) {
            return taxonomyAPI.fetchDomains(course.frameworkId, course.subjectId, course.courseId).then((domain) => {
                commit('fetchDomain', domain);
            });
        },

        fetchCodes({ commit }: { commit: any }, data: any) {
            return taxonomyAPI.fetchTaxonomyCodes(data.frameworkId, data.subjectId, data.courseId, data.domainId)
            .then((codes) => {
                const codesData = taxonomySerializer.normalizeCodeCompatencyBychild(codes);
                commit('fetchCodes', codesData);
            });
        },

        fetcSummaryCatalog(context: any, params: any) {
            const list = [
                searchAPI.fetchAggregationResources(params.resource),
                searchAPI.fetchAggregationQuestion(params.question),
            ];
            axios.all(list).then((response) => {
                context.commit('fetchSummaryCatalog', response);
            });
        },

        fetachLearnerContent(context: any, params: any) {
            const list = Object.keys(params).map((param: any) => {
                return searchAPI.fetachLearnerContents(params[param]);
            });
            return axios.all(list).then((response) => {
                context.commit('fetachLearnerContent', { params, response });
            });
        },

        courseCatalogSearch(context: any, params: any) {
            return searchAPI.fetchCourse(params)
                .then((courses) => {
                    context.commit('courseCatalogSearch', courses);
                    return courses.searchResults;
                });
        },

        collectionCatalogSearch(context: any, params: any) {
            return searchAPI.fetchCollections(params)
                .then((collection) => {
                    context.commit('collectionCatalogSearch', collection);
                    return collection.searchResults;
                });
        },
        offlineActivityCatalogSearch(context: any, params: any) {
            return searchAPI.fetchOfflineActivity(params)
                .then((offlineactivity) => {
                    context.commit('offlineActivityCatalogSearch', offlineactivity);
                    return offlineactivity.searchResults;
                });
        },
        assessmentCatalogSearch(context: any, params: any) {
            return searchAPI.fetchAssessment(params)
                .then((assessment) => {
                    context.commit('assessmentCatalogSearch', assessment);
                    return assessment.searchResults;
                });
        },
        resourceCatalogSearch(context: any, params: any) {
            return searchAPI.fetchResources(params)
                .then((resource) => {
                    context.commit('resourceCatalogSearch', resource);
                    return resource.searchResults;
                });
        },
        questionCatalogSearch(context: any, params: any) {
            return searchAPI.fetchQuestions(params)
                .then((question) => {
                    context.commit('questionCatalogSearch', question);
                    return question.searchResults;
                });
        },
        librariesCatalogSearch(context: any, params: any = null) {
            params = {};
            if (access.isCapLibrary) {
                params = { status: access.publisherStatus || 'unpublished' };
            }
            if (access.isDemoTenant) {
                params = { status: 'unpublished,published' };
            }
            return librariesAPI.fetchLibraries(params).then((libraries: any) => {
                context.commit('librariesCatalogSearch', { searchResults: libraries });
                return libraries;
            });
        },
        fetchCrossWalk(context: any, params: any) {
            return taxonomyAPI.fetchCrossWalk(params.id, params.subjectId, params.isMicro).then((crossWalk: any) => {
                context.commit('fetchCrossWalk', crossWalk);
            });
        },

        passSelectedData({ commit }: any, params: any) {
            commit('getSelectedData', params);
        },
    },
});
